import { render, staticRenderFns } from "./wine-sales.vue?vue&type=template&id=6f1011ad&scoped=true&"
import script from "./wine-sales.vue?vue&type=script&lang=js&"
export * from "./wine-sales.vue?vue&type=script&lang=js&"
import style0 from "./wine-sales.vue?vue&type=style&index=0&id=6f1011ad&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1011ad",
  null
  
)

export default component.exports